import type { ReactNode } from 'react'
import { FileCheck, Shield } from 'lucide-react'
import styles from '@/styles/components/tpsm/TpsmNavTabs.module.scss'

export type TpsmProfileSectionTab = 'compliance' | 'standards'

export type TpsmProfileSectionTabsProps = {
  active: TpsmProfileSectionTab
  onChange: (tab: TpsmProfileSectionTab) => void
  complianceLabel: string
  standardsLabel: string
}

/**
 * In-page tabs for supplier profile (same visual language as main TPSM section nav).
 */
export function TpsmProfileSectionTabs({
  active,
  onChange,
  complianceLabel,
  standardsLabel,
}: TpsmProfileSectionTabsProps) {
  const tabBtn = (id: TpsmProfileSectionTab, label: string, icon: ReactNode) => (
    <button
      key={id}
      type="button"
      role="tab"
      aria-selected={active === id}
      className={`${styles.tab} ${active === id ? styles.tabActive : ''}`.trim()}
      onClick={() => onChange(id)}
    >
      <span className={styles.tabIcon}>{icon}</span>
      <span className={styles.tabLabel}>{label}</span>
    </button>
  )

  return (
    <nav className={styles.root} aria-label="Supplier analytics">
      <div className={styles.track} role="tablist">
        {tabBtn('compliance', complianceLabel, <FileCheck aria-hidden />)}
        {tabBtn('standards', standardsLabel, <Shield aria-hidden />)}
      </div>
    </nav>
  )
}
